var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"templates"},[_c('TemplatesList'),(_vm.$permGuard.chP('templates.c'))?_c('TemplateCreate'):_vm._e()],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }